import { GlobalStore } from './global';
import { LayoutStore } from './layout';
import { StatusStore } from './status';
import { EhOperatorStore } from './ehOperator';
import { RejectStore } from './reject';
import { ShareStore } from './share';
import { OverTimeStore } from './overTime';
import { RequestWithdrawStore } from './requestWithdraw';
import { PrintLogStore } from './printLog';
import { FreeFlowStore } from './freeFlow';
import { PrintReqStore } from './printReq';
import SecondAuthStore from "./secondAuth";
import {SelectNextFlowStore} from './selectNextFlow';
import { RemindSetStore } from './remindSet';
import { LocationMapStore } from './locationMap';
import FollowSelectStore from './followSelect';
import { FieldLinkageCfg } from "./importFieldLinkageCfg";
import { FreeWflowSimple } from "./freeWorkflowSimple";
import { conformRules } from './conformRule';
//流程提交二次确认弹框
import { ensureSubmit } from './ensureSubmit';
//智能预测流程图strore
import  wfSmartGuessStore from './smartGuessWfStore';
import  ShowContentStore from './showContentStore';
module.exports = {
    globalStore: new GlobalStore(),
    layoutStore: new LayoutStore(),
    statusStore: new StatusStore(),
    ehOperatorStore: new EhOperatorStore(),
    rejectStore: new RejectStore(),
    shareStore: new ShareStore(),
    overTimeStore: new OverTimeStore(),
    printLogStore: new PrintLogStore(),
    freeFlowStore: new FreeFlowStore(),
    printReqStore: new PrintReqStore(),
    secondAuthStore : new SecondAuthStore(),
	selectNextFlowStore: new SelectNextFlowStore(),
    remindSetStore : new RemindSetStore(),
    locationMapStore : new LocationMapStore(),
    followSelectStore : new FollowSelectStore(),
    importFieldLinkageStore : new FieldLinkageCfg(),
    freeWflowSimpleStore : new FreeWflowSimple(),
    ensureSubmitStore: new ensureSubmit(),
    smartGuessStore: new wfSmartGuessStore(),
    requestWithdrawStore: new RequestWithdrawStore(),
    showContentStore: new ShowContentStore(),
    conformRuleStore: new conformRules()
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/stores/index.js